import React, { useEffect, useState } from 'react';
import moment from 'moment';
import './DateTime.css';

export default function DateTime(props: any) {
  const [tm, setTm] = useState<Date>();

  useEffect(() => {
    // Minimize the re-rendering of this code - it adjusts to once a minute, on the minute.
    const seconds = (new Date()).getSeconds();
    const secondsToDelay = 60 - seconds;
    const handle = setTimeout(() => {setTm(new Date())}, secondsToDelay * 1000);
    return () => clearTimeout(handle);
  }, [tm])

  return (
    <div className="time-container-parent">
    <div className="time-container">
    <div className="row">
      <div className="time-date">
        {moment(tm).format('M/D/YY')}
      </div>
      <div className="time-time">
        {moment(tm).format('h:mm A')}
      </div>
    </div>
  </div>
    </div>
  );
}
